import { render, staticRenderFns } from "./FireWhoMakesWorks.vue?vue&type=template&id=66868910&scoped=true"
import script from "./FireWhoMakesWorks.vue?vue&type=script&lang=ts"
export * from "./FireWhoMakesWorks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66868910",
  null
  
)

export default component.exports